import reducer from "./reducer";
export { default as OnboardingTracking } from "./components/index";
export { default as onboardingTrackingReducerName } from "./constants";
export default reducer;
